import { msalInstance, graphRequest } from '../../msalConfig';

const BASE = '/api';

// The B2 functions validate the Microsoft ID token (not the Graph access
// token), same as jarvis — same silent MSAL call, different field off the
// response.
async function getIdToken(forceRefresh) {
  const account = msalInstance.getAllAccounts()[0];
  if (!account) throw new Error('Not signed in');
  const response = await msalInstance.acquireTokenSilent({
    ...graphRequest,
    account,
    forceRefresh: !!forceRefresh,
  });
  return response.idToken;
}

// fetch with the ID token attached; on a 401, once more with a fresh token.
async function authedFetch(url, init = {}) {
  const send = async (forceRefresh) => fetch(url, {
    ...init,
    headers: { ...init.headers, Authorization: `Bearer ${await getIdToken(forceRefresh)}` },
  });
  const res = await send(false);
  return res.status === 401 ? send(true) : res;
}

export async function listOrphans() {
  const res = await authedFetch(`${BASE}/b2-list-orphans`);
  if (!res.ok) throw new Error(`listOrphans failed: ${res.status}`);
  return res.json();
}

export async function getSignedGetUrl(key) {
  const res = await authedFetch(`${BASE}/b2-signed-get`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ key }),
  });
  if (!res.ok) throw new Error(`getSignedGetUrl failed: ${res.status}`);
  const { url } = await res.json();
  return url;
}

export async function getSignedPutUrl(key, contentType) {
  const res = await authedFetch(`${BASE}/b2-signed-put`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ key, contentType }),
  });
  if (!res.ok) throw new Error(`getSignedPutUrl failed: ${res.status}`);
  const { url } = await res.json();
  return url;
}

export async function uploadCover(mediaKey, file) {
  const ext = file.name.split('.').pop().toLowerCase();
  const basename = mediaKey.replace(/\.[^.]+$/, '');
  const coverKey = `${basename}.cover.${ext}`;
  const putUrl = await getSignedPutUrl(coverKey, file.type);
  const uploadRes = await fetch(putUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
  if (!uploadRes.ok) throw new Error(`Cover upload failed: ${uploadRes.status}`);
  return coverKey;
}
